(function(){
  var root = document.querySelector('.po-form');
  if (!root || root.hasAttribute('data-po-init')) return;
  root.setAttribute('data-po-init','1');
 
  var ENDPOINT = 'https://chulani-ups-estimator-668440662953.us-central1.run.app/estimate';
  var CODES = { P:50,Q:45,R:40,S:35,T:30,U:25,V:20,W:15,X:10,Y:5,Z:0,NET:0 };
  var PER_TXT = { piece:'per piece', location:'per location', color:'per color', box:'per box' };
  // Charges naming 3rd party / UPS / FedEx belong to the Ship To section, not the item options.
  function isTP(label){ return /3rd\s*party|\bups\b|\bfedex\b/i.test(String(label)); }
 
  var CATALOG = [];
  try { CATALOG = JSON.parse(document.querySelector('.po-catalog').textContent) || []; } catch(e){ CATALOG = []; }
  CATALOG = CATALOG.filter(function(p){ return p && p.pricing && Array.isArray(p.pricing.priceBreaks) && p.pricing.priceBreaks.length; });
  CATALOG.sort(function(a,b){ return String(a.title).localeCompare(String(b.title)); });
  function prodLabel(p){ return p.title + (p.sku ? ' ['+p.sku+']' : ''); }
 
  function fmt(n){ return n < 1 ? n.toFixed(3) : n.toFixed(2); }
  function money2(n){ return n.toFixed(2); }
  function sortedBreaks(pr){ return pr.priceBreaks.map(function(b){ return {qty:parseInt(b.qty,10), retail:parseFloat(b.retail)}; }).filter(function(b){ return b.qty>0&&b.retail>0; }).sort(function(a,b){ return a.qty-b.qty; }); }
  function normComps(c){
    if (Array.isArray(c.components) && c.components.length) return c.components;
    return [{ amount:c.amount, code:c.code, per:(c.type==='per_piece'?'piece':''), note:c.note||'' }];
  }
  function netUnit(amount, code){
    var pct = CODES[code] != null ? CODES[code] : 0;
    var raw = amount * (1 - pct/100);
    return raw < 1 ? Number(raw.toFixed(3)) : Number(raw.toFixed(2));
  }
  // Rate-style pricing for one line: unit price text + charge text lines (no totals).
  function priceLine(prod, qty, selectedLabels, locCounts){
    var pr = prod.pricing, sb = sortedBreaks(pr);
    var minAllowed = Math.ceil(sb[0].qty/2);
    var bracket = sb[0];
    for (var i=0;i<sb.length;i++){ if (qty >= sb[i].qty) bracket = sb[i]; }
    var belowMin = qty < sb[0].qty;
    var code = String(pr.discountCode||'Z').toUpperCase();
    var nEach = netUnit(bracket.retail, code);
    var priceTxt = code==='NET'
      ? ('$'+fmt(bracket.retail)+'/Net')
      : ('$'+fmt(bracket.retail)+'/'+code+' ($'+fmt(nEach)+'/Net)');
    var mcq = parseFloat(pr.mcQty)||0;
    var boxes = mcq>0 ? Math.ceil(qty/mcq) : 0;
    var charges = []; var hasColor=false, hasLocation=false;
    function pushCharge(c, isOpt){
      var lbl = c.label;
      var isLoc = /location/i.test(lbl), isCol = /color/i.test(lbl) && !/pms/i.test(lbl);
      var N = isLoc ? Math.max(1, parseInt(locCounts && locCounts[lbl], 10) || 1) : 1;
      if (isOpt && isLoc) hasLocation = true;
      if (isOpt && isCol) hasColor = true;
      normComps(c).forEach(function(k){
        var amt = parseFloat(k.amount); if (!(amt>0)) return;
        var kCode = String(k.code||'Z').toUpperCase();
        var kNet = netUnit(amt, kCode);
        var base = kCode==='NET' ? ('$'+fmt(amt)+'/Net') : ('$'+fmt(amt)+'/'+kCode+' ($'+fmt(kNet)+'/Net)');
        var ctx = '';
        if (k.per==='location' || (!k.per && isLoc && N>1)) ctx = ' x '+N+' location'+(N>1?'s':'');
        else if (k.per==='box' && boxes>0) ctx = ' x '+boxes+' box'+(boxes>1?'es':'');
        charges.push({ label:(isOpt?'Requested: ':'')+lbl, text: base+(PER_TXT[k.per]?' '+PER_TXT[k.per]:'')+(k.note?' ('+k.note+')':'')+ctx });
      });
    }
    (pr.requiredCharges||[]).forEach(function(c){ if (c&&c.label) pushCharge(c,false); });
    (pr.optionalCharges||[]).forEach(function(c){ if (c&&c.label&&selectedLabels.indexOf(c.label)>-1) pushCharge(c,true); });
    if (belowMin) charges.push({ label:'Below Minimum Charge', text:'$25.00/Net' });
    return { minAllowed:minAllowed, belowMin:belowMin, priceTxt:priceTxt, charges:charges, hasColor:hasColor, hasLocation:hasLocation };
  }
 
  /* ── single item row ── */
  var itemsWrap = root.querySelector('.po-items');
  function itemRow(){
    var d = document.createElement('div');
    d.className = 'po-item';
    d.innerHTML =
      '<div class="po-picker">'+
        '<input type="text" class="po-i-search" placeholder="Search by Item # or product name *" autocomplete="off">'+
        '<div class="po-sugg"></div>'+
      '</div>'+
      '<select class="po-i-select"><option value="" selected disabled>*Select One* - browse all items</option>'+
        CATALOG.map(function(p,idx){ return '<option value="'+idx+'">'+prodLabel(p).replace(/</g,'&lt;')+'</option>'; }).join('')+
      '</select>'+
      '<div class="po-picked" hidden></div>'+
      '<div class="po-i-grid">'+
        '<div><span class="po-lab">Quantity *</span><input type="number" class="po-i-qty" min="1" step="1" placeholder="Qty"></div>'+
        '<div><span class="po-lab">Item Color *</span><input type="text" class="po-i-color" placeholder="e.g. Red"></div>'+
        '<div><span class="po-lab">Imprint Color *</span><input type="text" class="po-i-imp" placeholder="e.g. White"></div>'+
      '</div>'+
      '<label class="po-check"><input type="checkbox" class="po-i-noimp"> No imprint</label>'+
      '<label class="po-check"><input type="checkbox" class="po-proof"> Request a proof</label>'+
      '<div class="po-proof-wrap" hidden>'+
        '<span class="po-lab">Email to send proof to *</span>'+
        '<div class="po-proof-emails"><input type="email" class="po-proof-email" placeholder="name@company.com" style="max-width:320px;"></div>'+
        '<button type="button" class="po-mini po-proof-add">+ Add another email (CC, up to 5 total)</button>'+
      '</div>'+
      '<div class="po-charges" hidden></div>'+
      '<div class="po-line-price" hidden></div>';
    var search = d.querySelector('.po-i-search'), sugg = d.querySelector('.po-sugg'),
        sel = d.querySelector('.po-i-select'), picked = d.querySelector('.po-picked'),
        chWrap = d.querySelector('.po-charges'), lp = d.querySelector('.po-line-price');
    function pick(idx){
      d.setAttribute('data-prod', idx);
      var p = CATALOG[idx];
      picked.textContent = 'Selected: ' + prodLabel(p);
      picked.hidden = false;
      search.value = ''; sugg.style.display='none'; sel.value = String(idx);
      var opts = (p.pricing.optionalCharges||[]).filter(function(c){ return c&&c.label && !isTP(c.label); });
      chWrap.innerHTML = '';
      opts.forEach(function(c){
        var wrap = document.createElement('div');
        wrap.style.width = '100%';
        var lab = document.createElement('label'); lab.className='po-check';
        var box = document.createElement('input'); box.type='checkbox'; box.value=c.label; box.className='po-i-opt';
        lab.appendChild(box); lab.appendChild(document.createTextNode(' '+c.label));
        wrap.appendChild(lab);
        if (/location/i.test(c.label)){
          var extra = document.createElement('div');
          extra.className = 'po-loc-extra'; extra.hidden = true;
          extra.innerHTML =
            '<span class="po-lab"># of additional locations *</span>'+
            '<input type="number" class="po-i-locs" min="1" step="1" value="1" style="max-width:230px;">'+
            '<div class="po-warn" style="font-size:15px;">If the number of requested imprint locations exceeds the locations available on this item, Customer Service will contact you prior to processing.</div>';
          box.addEventListener('change', function(){ extra.hidden = !box.checked; });
          wrap.appendChild(extra);
        }
        if (/pms/i.test(c.label)){
          var extraP = document.createElement('div');
          extraP.className = 'po-loc-extra'; extraP.hidden = true;
          extraP.innerHTML =
            '<span class="po-lab">PMS # *</span>'+
            '<input type="text" class="po-i-pms" placeholder="e.g. 186 C" style="max-width:230px;">';
          box.addEventListener('change', function(){ extraP.hidden = !box.checked; });
          wrap.appendChild(extraP);
        } else if (/color/i.test(c.label)){
          var extraC = document.createElement('div');
          extraC.className = 'po-loc-extra'; extraC.hidden = true;
          extraC.innerHTML =
            '<span class="po-lab">Additional imprint color *</span>'+
            '<input type="text" class="po-i-addcolor" placeholder="e.g. Blue" style="max-width:230px;">';
          box.addEventListener('change', function(){ extraC.hidden = !box.checked; });
          wrap.appendChild(extraC);
        }
        chWrap.appendChild(wrap);
      });
      chWrap.hidden = !opts.length;
      updateLine();
    }
    function readLocCounts(){
      var map = {};
      d.querySelectorAll('.po-i-opt:checked').forEach(function(x){
        if (/location/i.test(x.value)){
          var locsEl = x.closest('div').parentNode.querySelector('.po-i-locs');
          if (locsEl) map[x.value] = parseInt(locsEl.value, 10) || 1;
        }
      });
      return map;
    }
    d.readLocCounts = readLocCounts;
    function updateLine(){
      var idx = d.getAttribute('data-prod');
      var qty = parseInt(d.querySelector('.po-i-qty').value,10)||0;
      if (idx===null || !qty){ lp.hidden = true; return; }
      var selCh = Array.prototype.map.call(d.querySelectorAll('.po-i-opt:checked'), function(x){ return x.value; });
      var L = priceLine(CATALOG[idx], qty, selCh, readLocCounts());
      if (qty < L.minAllowed){
        lp.textContent = 'Below absolute minimum - the minimum quantity that can be quoted for this item is '+L.minAllowed.toLocaleString()+' pieces.';
        lp.style.color = '#cc0000'; lp.hidden = false; return;
      }
      lp.hidden = true; // pricing appears on the generated PO only
    }
    function localMatches(q){
      var hits = [];
      for (var i=0;i<CATALOG.length && hits.length<10;i++){
        var p = CATALOG[i];
        if (String(p.title).toLowerCase().indexOf(q)>-1 || String(p.sku||'').toLowerCase().indexOf(q)>-1) hits.push(i);
      }
      return hits;
    }
    function renderSugg(idxs){
      sugg.innerHTML = idxs.length
        ? idxs.map(function(i){ return '<div data-i="'+i+'">'+prodLabel(CATALOG[i]).replace(/</g,'&lt;')+'</div>'; }).join('')
        : '<div style="color:#000;cursor:default;">No matches</div>';
      sugg.style.display = 'block';
    }
    var suggTimer = null;
    search.addEventListener('input', function(){
      var q = search.value.trim();
      if (!q){ sugg.style.display='none'; return; }
      clearTimeout(suggTimer);
      suggTimer = setTimeout(function(){
        fetch('/search/suggest.json?q='+encodeURIComponent(q)+
              '&resources[type]=product&resources[limit]=10'+
              '&resources[options][fields]=title,product_type,variants.sku,tag')
          .then(function(r){ return r.json(); })
          .then(function(dta){
            var prods = (dta && dta.resources && dta.resources.results && dta.resources.results.products) || [];
            var idxs = [];
            prods.forEach(function(p){
              for (var i=0;i<CATALOG.length;i++){
                if (CATALOG[i].handle === p.handle && idxs.indexOf(i)===-1){ idxs.push(i); break; }
              }
            });
            localMatches(q.toLowerCase()).forEach(function(i){
              if (idxs.indexOf(i)===-1 && idxs.length<10) idxs.push(i);
            });
            renderSugg(idxs.slice(0,10));
          })
          .catch(function(){ renderSugg(localMatches(q.toLowerCase())); });
      }, 250);
    });
    sugg.addEventListener('click', function(e){ var t=e.target.closest('[data-i]'); if (t) pick(parseInt(t.getAttribute('data-i'),10)); });
    document.addEventListener('click', function(e){ if (!d.contains(e.target)) sugg.style.display='none'; });
    sel.addEventListener('change', function(){ if (sel.value!=='') pick(parseInt(sel.value,10)); });
    d.addEventListener('input', updateLine);
    d.addEventListener('change', updateLine);
    d.querySelector('.po-i-noimp').addEventListener('change', function(){
      var imp = d.querySelector('.po-i-imp');
      imp.disabled = this.checked; if (this.checked) imp.value='';
      imp.placeholder = this.checked ? 'No imprint' : 'e.g. White';
    });
    var proofToggle = d.querySelector('.po-proof');
    var proofWrap = d.querySelector('.po-proof-wrap');
    proofToggle.addEventListener('change', function(){ proofWrap.hidden = !proofToggle.checked; });
    d.querySelector('.po-proof-add').addEventListener('click', function(){
      var wrapE = d.querySelector('.po-proof-emails');
      if (wrapE.querySelectorAll('.po-proof-email').length >= 5) return;
      var row = document.createElement('div');
      row.className = 'po-proof-row';
      row.innerHTML = '<input type="email" class="po-proof-email" placeholder="cc@company.com" style="max-width:320px;">'+
        '<button type="button" class="po-mini po-danger po-proof-rem">\u2715</button>';
      wrapE.appendChild(row);
      if (wrapE.querySelectorAll('.po-proof-email').length >= 5) d.querySelector('.po-proof-add').hidden = true;
    });
    d.addEventListener('click', function(e){
      if (e.target.classList.contains('po-proof-rem')){
        e.target.closest('.po-proof-row').remove();
        d.querySelector('.po-proof-add').hidden = false;
      }
    });
    return d;
  }
  itemsWrap.appendChild(itemRow());
 
  /* ── ship-to (Attn + Company separate) and bill-to ── */
  function billFields(){
    return '<input type="text" class="po-b-name" placeholder="Company / Attn *">'+
      '<input type="text" class="po-b-a1" placeholder="Street Address *">'+
      '<input type="text" class="po-b-a2" placeholder="Street Address 2 (optional)">'+
      '<div class="po-grid2">'+
        '<input type="text" class="po-b-city" placeholder="City *">'+
        '<input type="text" class="po-b-state" placeholder="State / Province *">'+
        '<input type="text" class="po-b-zip" placeholder="ZIP / Postal Code *">'+
        '<select class="po-b-country"><option value="" selected disabled>*Select One* - Country</option><option value="US">US</option><option value="CA">Canada</option></select>'+
      '</div>';
  }
  var shipsWrap = root.querySelector('.po-ships');
  function shipBlock(isFirst){
    var d = document.createElement('div');
    d.className = 'po-ship';
    d.innerHTML =
      '<input type="text" class="po-s-attn" placeholder="Attn - Contact Name *">'+
      '<input type="text" class="po-s-name" placeholder="Company Name *">'+
      '<input type="text" class="po-s-a1" placeholder="Street Address *">'+
      '<input type="text" class="po-s-a2" placeholder="Street Address 2 (optional)">'+
      '<div class="po-grid2">'+
        '<input type="text" class="po-s-city" placeholder="City *">'+
        '<input type="text" class="po-s-state" placeholder="State / Province *">'+
        '<input type="text" class="po-s-zip" placeholder="ZIP / Postal Code *">'+
        '<select class="po-s-country"><option value="" selected disabled>*Select One* - Country</option><option value="US">US</option><option value="CA">Canada</option></select>'+
      '</div>'+
      '<div class="po-s-svcs" hidden></div>'+
      '<div class="po-s-qtywrap"'+(isFirst?' hidden':'')+'>'+
        '<span class="po-lab">Quantity to this address *</span>'+
        '<input type="number" class="po-s-qty" min="1" step="1" placeholder="e.g. 500">'+
      '</div>'+
      (isFirst ? '' :
      '<div class="po-actions">'+
        '<button type="button" class="po-mini po-s-clear">Clear fields</button>'+
        '<button type="button" class="po-mini po-danger po-s-remove">Remove</button>'+
      '</div>');
    return d;
  }
  shipsWrap.appendChild(shipBlock(true));
  function updateSplitVisibility(){
    var blocks = shipsWrap.querySelectorAll('.po-ship');
    if (blocks[0]){
      var sp = blocks[0].querySelector('.po-s-qtywrap');
      if (sp) sp.hidden = blocks.length < 2;
    }
  }
  updateSplitVisibility();
  root.querySelector('.po-add-ship').addEventListener('click', function(){
    var nb = shipBlock(false);
    shipsWrap.appendChild(nb);
    refreshShipSvcs();
    updateSplitVisibility();
    refreshFreightUI();
  });
  root.querySelector('.po-bill').innerHTML = billFields();
 
  root.addEventListener('click', function(e){
    var blk = e.target.closest('.po-ship');
    if (!blk) return;
    if (e.target.classList.contains('po-s-clear')){
      blk.querySelectorAll('input[type=text]').forEach(function(i){ i.value=''; });
    } else if (e.target.classList.contains('po-s-remove')){
      blk.remove();
      refreshShipSvcs();
      updateSplitVisibility();
      refreshFreightUI();
    }
  });
 
  /* ── per-address shipping service (3rd party mode: pick exactly one) ── */
  var SHIP_SVC_LABELS = {
    US: ['Ground','3 Day','2 Day','1 Day'],
    CA: ['Standard','Worldwide Expedited','Worldwide Saver','Worldwide Express']
  };
  function renderShipSvcs(block){
    var wrap = block.querySelector('.po-s-svcs');
    if (!wrap) return;
    var third = root.querySelector('input[name=po-shipacct]:checked').value === 'third';
    var multi = shipsWrap.querySelectorAll('.po-ship').length > 1;
    if (!third && !multi){ wrap.hidden = true; wrap.innerHTML=''; return; }
    var country = block.querySelector('.po-s-country').value;
    var list = SHIP_SVC_LABELS[country] || SHIP_SVC_LABELS.US;
    var keep = (wrap.querySelector('.po-s-svc:checked')||{}).value;
    wrap.innerHTML = '<span class="po-lab">Shipping service for this address * (select one)</span>' +
      list.map(function(s){
        return '<label class="po-check" style="display:inline-flex;margin-right:14px;">'+
          '<input type="checkbox" class="po-s-svc" value="'+s+'"'+(keep===s?' checked':'')+'> '+s+'</label>';
      }).join('');
    wrap.hidden = false;
  }
  function refreshShipSvcs(){
    shipsWrap.querySelectorAll('.po-ship').forEach(renderShipSvcs);
  }
  shipsWrap.addEventListener('change', function(e){
    if (e.target.classList.contains('po-s-svc') && e.target.checked){
      e.target.closest('.po-s-svcs').querySelectorAll('.po-s-svc').forEach(function(cb){
        if (cb !== e.target) cb.checked = false;
      });
    }
  });
 
  /* Membership checkboxes reveal their number inputs */
  root.querySelectorAll('.po-mem').forEach(function(cb){
    cb.addEventListener('change', function(){
      var extra = cb.closest('label').nextElementSibling;
      if (extra && extra.classList.contains('po-mem-extra')) extra.hidden = !cb.checked;
    });
  });
 
  /* ── shipping account, freight, in-hands ── */
  var freightArea = root.querySelector('.po-freight-area');
  function refreshAcct(){
    var third = root.querySelector('input[name=po-shipacct]:checked').value === 'third';
    root.querySelector('.po-third').hidden = !third;
    freightArea.hidden = third;
    refreshShipSvcs();
  }
  root.querySelectorAll('input[name=po-shipacct]').forEach(function(r){
    r.addEventListener('change', refreshAcct);
  });
  refreshAcct();
 
  var FREIGHT_SVCS = {
    US: [['Ground','UPS Ground'],['3Day','UPS 3 Day Select'],['2Day','UPS 2nd Day Air'],['1Day','UPS Next Day Air']],
    CA: [['Standard','UPS Standard'],['Worldwide Expedited','UPS Worldwide Expedited'],['Worldwide Saver','UPS Worldwide Saver'],['Worldwide Express','UPS Worldwide Express']]
  };
  var freightSvc = root.querySelector('.po-freight-svc');
  function fillFreightSvcs(){
    var firstShip = shipsWrap.querySelector('.po-ship');
    var country = firstShip ? firstShip.querySelector('.po-s-country').value : '';
    var list = FREIGHT_SVCS[country] || FREIGHT_SVCS.US;
    freightSvc.innerHTML = '<option value="" selected disabled>*Select One* - Shipping service</option>' +
      list.map(function(s){ return '<option value="'+s[0]+'">'+s[1]+'</option>'; }).join('');
  }
  fillFreightSvcs();
  shipsWrap.addEventListener('change', function(e){
    if (e.target.classList.contains('po-s-country')){
      fillFreightSvcs();
      var blk = e.target.closest('.po-ship');
      if (blk) renderShipSvcs(blk);
    }
  });
  var freightToggle = root.querySelector('.po-freight-toggle');
  function refreshFreightUI(){
    var multi = shipsWrap.querySelectorAll('.po-ship').length > 1;
    root.querySelector('.po-freight-svc-wrap').hidden = !freightToggle.checked || multi;
  }
  freightToggle.addEventListener('change', refreshFreightUI);
  refreshFreightUI();
 
  var ihMode = root.querySelector('.po-inhands-mode');
  var ihDate = root.querySelector('.po-inhands');
  ihMode.addEventListener('change', function(){ ihDate.hidden = (ihMode.value !== 'flexible' && ihMode.value !== 'firm'); });
  ihDate.addEventListener('click', function(){ if (this.showPicker){ try { this.showPicker(); } catch(e){} } });
 
  var msg = root.querySelector('.po-msg');
  function show(t, ok){ msg.textContent=t; msg.className='po-msg '+(ok?'po-ok':'po-err'); msg.hidden=false; }
  function val(sel, scope){ var el=(scope||root).querySelector(sel); return el?el.value.trim():''; }
  function readShip(scope){
    return { attn:val('.po-s-attn',scope), name:val('.po-s-name',scope), a1:val('.po-s-a1',scope), a2:val('.po-s-a2',scope),
      city:val('.po-s-city',scope), state:val('.po-s-state',scope), zip:val('.po-s-zip',scope), country:val('.po-s-country',scope) };
  }
  function readBill(){
    var scope = root.querySelector('.po-bill');
    return { name:val('.po-b-name',scope), a1:val('.po-b-a1',scope), a2:val('.po-b-a2',scope),
      city:val('.po-b-city',scope), state:val('.po-b-state',scope), zip:val('.po-b-zip',scope), country:val('.po-b-country',scope) };
  }
  function shipComplete(a){ return a.attn&&a.name&&a.a1&&a.city&&a.state&&a.zip&&a.country; }
  function billComplete(a){ return a.name&&a.a1&&a.city&&a.state&&a.zip&&a.country; }
  function shipLines(a){
    var out=[ 'Attn: '+a.attn, a.name, a.a1 ]; if (a.a2) out.push(a.a2);
    out.push(a.city+', '+a.state+' '+a.zip+' ('+a.country+')'); return out;
  }
  function billLines(a){
    var out=[ a.name, a.a1 ]; if (a.a2) out.push(a.a2);
    out.push(a.city+', '+a.state+' '+a.zip+' ('+a.country+')'); return out;
  }
 
  /* ── generate ── */
  root.querySelector('.po-download').addEventListener('click', function(){
    var btn = this;
    var company=val('.po-company'), contact=val('.po-contact'), phone=val('.po-phone'), email=val('.po-email');
    if (!company||!contact||!phone||!email){ show('Please fill in all company/contact fields.', false); return; }
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){ show('Please enter a valid email address.', false); return; }
 
    var members = [];
    var memErr = null;
    root.querySelectorAll('.po-mem:checked').forEach(function(cb){
      var org = cb.getAttribute('data-mem');
      var numEl = root.querySelector('.po-mem-num[data-mem="'+org+'"]');
      var num = numEl ? numEl.value.trim() : '';
      if (!num){ memErr = 'Please enter your '+org+' # (or uncheck it).'; }
      members.push({ org:org, num:num });
    });
    if (memErr){ show(memErr, false); return; }
 
    var bl = root.querySelector('.po-item');
    var idx = bl.getAttribute('data-prod');
    if (idx===null){ show('Please select a product (search or browse).', false); return; }
    var qty = parseInt(val('.po-i-qty',bl),10)||0;
    var col = val('.po-i-color',bl);
    var noimp = bl.querySelector('.po-i-noimp').checked, imp = noimp?'No imprint':val('.po-i-imp',bl);
    if (!qty||!col||(!noimp&&!imp)){ show('Please complete Quantity, Item Color, and Imprint Color (or check No imprint).', false); return; }
    var prod = CATALOG[idx];
    var selCh = Array.prototype.map.call(bl.querySelectorAll('.po-i-opt:checked'), function(x){ return x.value; });
    var addColor = '';
    var colorChecked = false;
    var pms = '';
    var pmsChecked = false;
    bl.querySelectorAll('.po-i-opt:checked').forEach(function(x){
      if (/pms/i.test(x.value)){
        pmsChecked = true;
        var pEl = x.closest('div').parentNode.querySelector('.po-i-pms');
        if (pEl) pms = pEl.value.trim();
      } else if (/color/i.test(x.value)){
        colorChecked = true;
        var acEl = x.closest('div').parentNode.querySelector('.po-i-addcolor');
        if (acEl) addColor = acEl.value.trim();
      }
    });
    if (colorChecked && !addColor){ show('Please enter the additional imprint color.', false); return; }
    if (pmsChecked && !pms){ show('Please enter the PMS #.', false); return; }
    var proofEmails = [];
    if (bl.querySelector('.po-proof').checked){
      var pes = bl.querySelectorAll('.po-proof-email');
      for (var pe=0; pe<pes.length; pe++){
        var pv = pes[pe].value.trim();
        if (pe===0 && !pv){ show('Please enter the email address to send the proof to.', false); return; }
        if (pv && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(pv)){ show('Proof email #'+(pe+1)+' is not a valid email address.', false); return; }
        if (pv) proofEmails.push(pv);
      }
    }
    var P = priceLine(prod, qty, selCh, bl.readLocCounts());
    if (qty < P.minAllowed){ show('Minimum quantity for this item is '+P.minAllowed.toLocaleString()+' pieces.', false); return; }
    var line = { prod:prod, qty:qty, color:col, imprint:imp, addColor:addColor, pms:pms, proof:proofEmails, price:P };
 
    var shipBlocks=root.querySelectorAll('.po-ship'); var ships=[];
    for (var s=0;s<shipBlocks.length;s++){
      var a=readShip(shipBlocks[s]);
      if (!shipComplete(a)){ show('Ship-To address #'+(s+1)+': please complete all required fields including Attn, Company, and country (or remove it).', false); return; }
      a.qty = parseInt(val('.po-s-qty',shipBlocks[s]),10) || 0;
      if (shipBlocks.length > 1 && a.qty < 1){ show('Ship-To address #'+(s+1)+': please enter the quantity shipping to this address.', false); return; }
      if (shipBlocks.length === 1) a.qty = 0;
      ships.push(a);
    }
    var bill=readBill();
    if (!billComplete(bill)){ show('Please complete the Bill To address, including country.', false); return; }
 
    var third = root.querySelector('input[name=po-shipacct]:checked').value==='third';
    var carrier=val('.po-carrier'), acct=val('.po-acct');
    if (third && !carrier){ show('Please select the 3rd party carrier (UPS or FedEx).', false); return; }
    if (third && !acct){ show('Please enter the 3rd party account #.', false); return; }
    if (third || shipBlocks.length > 1){
      for (var t2=0;t2<shipBlocks.length;t2++){
        var svcEl = shipBlocks[t2].querySelector('.po-s-svc:checked');
        if (!svcEl){ show('Please select one shipping service for ship-to address #'+(t2+1)+'.', false); return; }
        ships[t2].service = svcEl.value;
      }
    }
    var ponum=val('.po-ponum');
    if (!ponum){ show('Please enter your PO #.', false); return; }
    var ihm = ihMode.value, inhands=val('.po-inhands');
    if (!ihm){ show('Please select an in-hands date option.', false); return; }
    if (ihm !== 'standard' && !inhands){ show('Please select the in-hands date.', false); return; }
    var special=val('.po-special'), discount=val('.po-discount');
 
    var wantFreight = !third && freightToggle.checked;
    var svcKey = freightSvc.value;
    if (wantFreight && ships.length === 1 && !svcKey){ show('Please select a shipping service for the freight estimate.', false); return; }
 
    var SVC_KEY = {'Ground':'Ground','3 Day':'3Day','2 Day':'2Day','1 Day':'1Day',
      'Standard':'Standard','Worldwide Expedited':'Worldwide Expedited','Worldwide Saver':'Worldwide Saver','Worldwide Express':'Worldwide Express'};
    function getEstimate(zip, country, q, key){
      return fetch(ENDPOINT,{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({zip:zip,country:country,quantity:q,masterCartonQty:parseFloat(prod.pricing.mcQty),masterCartonWeight:parseFloat(prod.pricing.mcWeight)})})
        .then(function(r){ return r.json(); })
        .then(function(dta){
          if (!dta||!dta.success||!dta.rates) return null;
          var r=dta.rates[key];
          if (!r){ var ks=Object.keys(dta.rates); for (var k=0;k<ks.length;k++){ if (ks[k].toLowerCase().indexOf(String(key).toLowerCase())>-1){ r=dta.rates[ks[k]]; break; } } }
          return r ? { cost:r.cost, currency:r.currency||'USD' } : null;
        }).catch(function(){ return null; });
    }
 
    var mcOK = parseFloat(prod.pricing.mcQty)>0 && parseFloat(prod.pricing.mcWeight)>0;
    var freightPromise = Promise.resolve(null);      // single-address estimate
    var multiFreightPromise = Promise.resolve(null); // per-address estimates
    if (wantFreight && mcOK){
      if (ships.length === 1){
        freightPromise = getEstimate(ships[0].zip, ships[0].country, qty, svcKey);
      } else {
        multiFreightPromise = Promise.all(ships.map(function(a){
          return getEstimate(a.zip, a.country, a.qty, SVC_KEY[a.service] || a.service);
        }));
      }
    }
 
    btn.disabled = true; btn.textContent = wantFreight ? 'Calculating freight & building PDF...' : 'Building PDF...';
    msg.hidden = true;
 
    Promise.all([freightPromise, multiFreightPromise]).then(function(res){
      if (res[1]) res[1].forEach(function(f,i){ ships[i].freight = f; });
      buildPdf(line, ships, bill, {company:company,contact:contact,phone:phone,email:email,ponum:ponum,members:members},
        {third:third,carrier:carrier,acct:acct}, {mode:ihm, date:inhands}, special, discount,
        (wantFreight && ships.length === 1)
          ? {svcName:(freightSvc.options[freightSvc.selectedIndex]||{}).text||svcKey, est:res[0]}
          : null);
    }).catch(function(){
      show('Something went wrong building the PDF. Please try again.', false);
    }).then(function(){
      btn.disabled=false; btn.textContent='Download Purchase Order (PDF)';
    });
  });
 
  /* ── clean one-page PDF ── */
  function buildPdf(L, ships, bill, co, shipAcct, inhands, special, discount, freight){
    var jsPDF = window.jspdf && window.jspdf.jsPDF;
    if (!jsPDF){ show('PDF library failed to load - please refresh and try again.', false); return; }
    var doc = new jsPDF({unit:'pt',format:'letter',
      encryption:{ ownerPassword:'chulani-po-lock', userPermissions:['print'] }});
    var pageW=612, pageH=792, m=40;
 
    function stampWatermark(){
      var c = 0.7071, off = 30;
      var cx = pageW/2 + c*off, cy = pageH/2 + c*off;
      doc.setFont('helvetica','bold');
      doc.setTextColor(228,228,228);
      doc.setFontSize(150);
      var w1 = doc.getTextWidth('CHULANI');
      doc.text('CHULANI', cx - c*w1/2, cy + c*w1/2, { angle: 45 });
      doc.setFont('helvetica','normal');
      doc.setFontSize(15);
      var s2 = 'ASI 45100  |  SAGE 50625  |  order@chulani.com  |  973-279-6666';
      var w2 = doc.getTextWidth(s2), dPerp = 105;
      doc.text(s2, cx + c*dPerp - c*w2/2, cy + c*dPerp + c*w2/2, { angle: 45 });
      doc.setTextColor(0,0,0);
    }
    stampWatermark();
 
    // put(): write wrapped text at x within width w starting at baseline y; returns next y
    function put(x, w, y0, t, size, bold){
      doc.setFont('helvetica', bold?'bold':'normal');
      doc.setFontSize(size);
      var ls = doc.splitTextToSize(String(t), w);
      doc.text(ls, x, y0);
      return y0 + ls.length * size * 1.32;
    }
 
    // Title
    doc.setFont('helvetica','bold'); doc.setFontSize(23);
    doc.text('PURCHASE ORDER', pageW/2, 62, {align:'center'});
 
    var today = new Date().toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'});
    var ihTxt;
    if (inhands.mode==='standard'){ ihTxt='Standard production'; }
    else {
      ihTxt = new Date(inhands.date+'T12:00:00').toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'}) +
        (inhands.mode==='firm' ? ' (FIRM)' : ' (Flexible)');
    }
    var multiShip = ships.length > 1;
    var topY = 96;
 
    // LEFT column: distributor, bill to, vendor
    var lx=m, lw=290, yL=topY;
    yL = put(lx,lw,yL, co.company, 14, true);
    yL = put(lx,lw,yL, 'Contact: '+co.contact, 11, false);
    yL = put(lx,lw,yL, co.phone, 11, false);
    yL = put(lx,lw,yL, co.email, 11, false);
    if (co.members && co.members.length){
      yL = put(lx,lw,yL, 'Member: '+co.members.map(function(mm){ return mm.org+' #'+mm.num; }).join('  |  '), 10.5, false);
    }
    yL += 12;
    yL = put(lx,lw,yL, 'BILL TO', 11.5, true);
    billLines(bill).forEach(function(t){ yL = put(lx,lw,yL, t, 11, false); });
    yL += 12;
    yL = put(lx,lw,yL, 'FOR: Chulani Promotional Products', 11.5, true);
    yL = put(lx,lw,yL, 'order@chulani.com  |  973-279-6666', 11, false);
    yL = put(lx,lw,yL, 'www.chulani.com', 11, false);
    yL = put(lx,lw,yL, 'ASI # 45100  |  SAGE # 50625', 11, false);
 
    // RIGHT column: PO#, date, in-hands, ship to, ship via
    var rx=356, rw=216, yR=topY;
    yR = put(rx,rw,yR, 'PO #: '+co.ponum, 13, true);
    yR = put(rx,rw,yR, 'Date: '+today, 11, false);
    yR = put(rx,rw,yR, 'In-Hands: '+ihTxt, 11, inhands.mode==='firm');
    yR += 10;
    if (!multiShip){
      yR = put(rx,rw,yR, 'SHIP TO', 11.5, true);
      var a0 = ships[0];
      shipLines(a0).forEach(function(t){ yR = put(rx,rw,yR, t, 10.5, false); });
      if (shipAcct.third && a0.service) yR = put(rx,rw,yR, 'Service: '+a0.service, 10.5, true);
    } else {
      yR = put(rx,rw,yR, 'SHIP TO - SPLIT ('+ships.length+' LOCATIONS)', 11.5, true);
      yR = put(rx,rw,yR, 'See page 2 for all ship-to addresses.', 10.5, false);
    }
    yR += 10;
    yR = put(rx,rw,yR, 'SHIP VIA', 11.5, true);
    if (shipAcct.third){
      yR = put(rx,rw,yR, '3rd Party '+shipAcct.carrier+' Account #'+shipAcct.acct, 10.5, false);
      yR = put(rx,rw,yR, 'Freight billed to your account', 10.5, false);
    } else {
      yR = put(rx,rw,yR, 'Chulani Account', 10.5, false);
      yR = put(rx,rw,yR, '(freight charges billed on invoice)', 10.5, false);
      if (freight){
        yR = put(rx,rw,yR, freight.svcName, 10.5, false);
        if (freight.est){
          yR = put(rx,rw,yR, 'Est. Freight: $'+money2(freight.est.cost)+(ships[0].country==='CA' ? ' '+freight.est.currency : ''), 11, true);
        } else {
          yR = put(rx,rw,yR, 'Freight quoted at processing', 10.5, false);
        }
      }
      if (multiShip && ships.some(function(a){ return a.freight; })){
        yR = put(rx,rw,yR, 'Freight estimates shown per address on page 2.', 10, false);
      }
    }
 
    var y = Math.max(yL, yR) + 12;
    doc.setDrawColor(37,68,196); doc.setLineWidth(1.2);
    doc.line(m, y, pageW-m, y); y += 16;
 
    // Disclaimer (solid black; submission sentence bold)
    doc.setFont('helvetica','italic'); doc.setFontSize(9.5); doc.setTextColor(0,0,0);
    var discl = doc.splitTextToSize('This document is a preliminary purchase order request prepared for order organization and submission purposes only; it is not an invoice or order confirmation. Pricing, item colors, quantities, and production timelines are subject to review and may change. Customer Service will review this request and contact you regarding any questions, clarifications, or discrepancies prior to order processing.', pageW-2*m);
    doc.text(discl, m, y); y += discl.length*12.6 + 2;
    doc.setFont('helvetica','bolditalic'); doc.setFontSize(9.5);
    var discl2 = doc.splitTextToSize('This purchase order must be submitted to order@chulani.com; it is not automatically transmitted when this document is generated.', pageW-2*m);
    doc.text(discl2, m, y); y += discl2.length*12.6 + 10;
 
    // PRODUCT
    y = put(m, pageW-2*m, y, 'PRODUCT', 12.5, true) + 2;
    y = put(m, pageW-2*m, y, L.prod.title + (L.prod.sku ? '  ['+L.prod.sku+']' : ''), 11.5, true) + 4;
 
    // Table: Item Color | Imprint Color | Quantity | Per Piece Pricing
    var thY = y;
    doc.setFillColor(238,240,249);
    doc.rect(m, thY-12, pageW-2*m, 20, 'F');
    doc.setFont('helvetica','bold'); doc.setFontSize(10.5); doc.setTextColor(0,0,0);
    var cX = [m+6, m+128, m+262, m+352];
    doc.text('Item Color', cX[0], thY+2);
    doc.text('Imprint Color', cX[1], thY+2);
    doc.text('Quantity', cX[2], thY+2);
    doc.text('Per Piece Pricing', cX[3], thY+2);
    y = thY + 24;
    doc.setFont('helvetica','normal'); doc.setFontSize(10.5);
    doc.text(String(L.color).slice(0,22), cX[0], y);
    doc.text(String(L.imprint).slice(0,24), cX[1], y);
    doc.text(L.qty.toLocaleString()+(L.price.belowMin?' *':''), cX[2], y);
    doc.text(L.price.priceTxt, cX[3], y);
    y += 18;
    if (L.addColor){
      y = put(m, pageW-2*m, y, 'Additional Imprint Color: '+L.addColor, 10.5, false) + 2;
    }
    if (L.pms){
      y = put(m, pageW-2*m, y, 'PMS #: '+L.pms, 10.5, false) + 2;
    }
    if (L.proof && L.proof.length){
      var pTxt = 'Proof Requested - send to: '+L.proof[0]+(L.proof.length>1 ? '  (CC: '+L.proof.slice(1).join(', ')+')' : '');
      y = put(m, pageW-2*m, y, pTxt, 10.5, true) + 2;
    }
    if (L.price.belowMin){
      y = put(m, pageW-2*m, y, '* Quantity below lowest published bracket - priced at that bracket; Below Minimum Charge applies.', 9, false) + 2;
    }
    y += 8;
 
    // CHARGES (rates only, no totals)
    y = put(m, pageW-2*m, y, 'CHARGES', 12.5, true) + 2;
    L.price.charges.forEach(function(c){
      y = put(m+6, pageW-2*m-6, y, '\u2022  '+c.label+' - '+c.text, 10.5, false) + 1;
    });
    if (shipAcct.third){
      var mcq2 = parseFloat(L.prod.pricing.mcQty)||0;
      var boxes2 = mcq2>0 ? Math.ceil(L.qty/mcq2) : 0;
      (L.prod.pricing.optionalCharges||[]).forEach(function(c){
        if (!(c && c.label) || !isTP(c.label)) return;
        normComps(c).forEach(function(k){
          var amt = parseFloat(k.amount); if (!(amt>0)) return;
          var kCode = String(k.code||'Z').toUpperCase();
          var kNet = netUnit(amt, kCode);
          var base = kCode==='NET' ? ('$'+fmt(amt)+'/Net') : ('$'+fmt(amt)+'/'+kCode+' ($'+fmt(kNet)+'/Net)');
          var ctx = (k.per==='box' && boxes2>0) ? ' x '+boxes2+' box'+(boxes2>1?'es':'') : '';
          y = put(m+6, pageW-2*m-6, y,
            '\u2022  '+c.label+' - '+base+(PER_TXT[k.per]?' '+PER_TXT[k.per]:'')+(k.note?' ('+k.note+')':'')+ctx,
            10.5, false) + 1;
        });
      });
    }
    if (ships.length>1){
      y = put(m+6, pageW-2*m-6, y, '\u2022  Split (Additional Ship To Addresses) - $7.00/Net per location x '+(ships.length-1), 10.5, false) + 1;
    }
    y += 8;
 
    // Imprint notices (red, only when relevant)
    doc.setTextColor(204,0,0);
    if (L.price.hasColor){
      doc.setFont('helvetica','bold'); doc.setFontSize(9.5);
      var n1 = doc.splitTextToSize('Maximum of two (2) spot color imprint only. If the artwork cannot be imprinted due to tight color registration, Customer Service will contact you prior to production.', pageW-2*m);
      doc.text(n1, m, y); y += n1.length*12.4 + 4;
    }
    if (L.price.hasLocation){
      doc.setFont('helvetica','bold'); doc.setFontSize(9.5);
      var n2 = doc.splitTextToSize('If the number of requested imprint locations exceeds the locations available on this item, Customer Service will contact you prior to processing.', pageW-2*m);
      doc.text(n2, m, y); y += n2.length*12.4 + 4;
    }
    doc.setTextColor(0,0,0);
    y += 4;
 
    // Discount code + warning (only when a code was entered)
    if (discount){
      y = put(m, pageW-2*m, y, 'Discount Code: '+discount, 11.5, true) + 1;
      doc.setTextColor(204,0,0); doc.setFont('helvetica','bold'); doc.setFontSize(9.5);
      var dw = doc.splitTextToSize('Discount codes are applied by customer service when processing the order and will not reflect on this PO generated.', pageW-2*m);
      doc.text(dw, m, y); y += dw.length*12.4 + 8;
      doc.setTextColor(0,0,0);
    }
 
    // Special requests (only if provided)
    if (special){
      y = put(m, pageW-2*m, y, 'SPECIAL REQUESTS', 12.5, true) + 2;
      y = put(m+6, pageW-2*m-6, y, special, 10.5, false) + 8;
    }
 
    // Footer
    doc.setDrawColor(37,68,196); doc.line(m, y, pageW-m, y); y += 16;
    y = put(m, pageW-2*m, y, 'Please email this purchase order to order@chulani.com. This document is generated for your records and is not automatically transmitted to or received by Chulani Promotional Products.', 10, true);
 
    // Page 2+: all ship-to addresses when multiple, header repeating on overflow
    if (multiShip){
      function shipPageHeader(){
        var yl = 58;
        yl = put(m, 300, yl, co.company, 13, true);
        yl = put(m, 300, yl, 'Contact: '+co.contact, 10.5, false);
        yl = put(m, 300, yl, co.phone+'  |  '+co.email, 10.5, false);
        var yr2 = 58;
        yr2 = put(400, 172, yr2, 'PO #: '+co.ponum, 12, true);
        yr2 = put(400, 172, yr2, 'Date: '+today, 10.5, false);
        yr2 = put(400, 172, yr2, 'In-Hands: '+ihTxt, 10.5, inhands.mode==='firm');
        var yy = Math.max(yl, yr2) + 8;
        doc.setDrawColor(37,68,196); doc.setLineWidth(1.2);
        doc.line(m, yy, pageW-m, yy); yy += 16;
        yy = put(m, pageW-2*m, yy, 'SHIP TO - SPLIT DESTINATION ('+ships.length+' LOCATIONS)', 12.5, true) + 4;
        return yy;
      }
      doc.addPage(); stampWatermark();
      var y2 = shipPageHeader();
      ships.forEach(function(a, i){
        var lines2 = shipLines(a);
        var need = (lines2.length + 5) * 14 + 12;
        if (y2 + need > pageH - 56){
          doc.addPage(); stampWatermark();
          y2 = shipPageHeader();
        }
        y2 = put(m, pageW-2*m, y2, 'Ship-To '+(i+1)+':', 11.5, true);
        lines2.forEach(function(t){ y2 = put(m+12, pageW-2*m-12, y2, t, 10.5, false); });
        if (a.qty > 0) y2 = put(m+12, pageW-2*m-12, y2, 'Quantity: '+a.qty.toLocaleString()+' pcs', 10.5, true);
        if (a.service) y2 = put(m+12, pageW-2*m-12, y2, 'Service: '+a.service, 10.5, true);
        if (!shipAcct.third && a.freight){
          y2 = put(m+12, pageW-2*m-12, y2, 'Est. Freight: $'+money2(a.freight.cost)+(a.country==='CA' ? ' '+a.freight.currency : ''), 10.5, true);
        } else if (!shipAcct.third && !a.freight && ships.some(function(x){ return x.freight; })){
          y2 = put(m+12, pageW-2*m-12, y2, 'Est. Freight: quoted at processing', 10.5, false);
        }
        y2 += 10;
      });
    }
 
    var fname='PO-'+co.company.replace(/[^a-z0-9]+/gi,'-').replace(/^-|-$/g,'')+'-'+new Date().toISOString().slice(0,10)+'.pdf';
    doc.save(fname);
    show('Purchase order downloaded ('+fname+'). Please email it to order@chulani.com.', true);
  }
})();